<nz-card class="participant-info-field">
	<div class="info-box">
		<div class="text-dark font-weight-bold font-size-18">
			{{ participantInfo }}
		</div>
		<div *ngFor="let detail of participantInfoDetails" class="participant-details">
			<ng-container *ngIf="detail.label">{{detail.label}}:</ng-container>
			{{detail.value}}
		</div>
		<div *ngIf="showParticipantRole" class="participant-details">
			{{ participantRole | translate | titlecase }}
		</div>
		<div *ngIf="showCreationDate" class="participant-details">
			{{ 'user.createdDate' | translate }}: {{ participantCreationDate }}
		</div>
		<app-splitbutton [elements]="goToEditButton"></app-splitbutton>
	</div>
</nz-card>

<nz-card class="flow">
	<ol workflow-steps></ol>
</nz-card>

<nz-card *ngIf="showQueryEdit$ | async" [nzTitle]="'query.card.title' | translate">
	<workflow-query-panel></workflow-query-panel>
</nz-card>